import styled from "styled-components";

export const HomePageStyles = styled.div`
    
`;